import { Spinner } from "react-bootstrap";

export function ButtonSpinnerOverlay() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center position-absolute top-0 start-0 end-0 bottom-0 text-white">
      <Spinner />
    </div>
  )
}